import { apiService } from "core/services/apiService";
import Cookies from "js-cookie";
import { CreateDeviceRequest, GetDevicesResponse } from "types";



// Get Device
export const getDevices = async (): Promise<GetDevicesResponse | null> => {
    const workplaceId = Number(localStorage.getItem("workplace-id"));

    try {
        const response = await apiService.get<any>(
            `/devices?workplace=${workplaceId}&limit=5`
        );
        
        // Handle both response formats:
        // 1. Direct array: [...]
        // 2. Wrapped format: { items: [...] }
        let devicesArray: any[] = [];
        
        if (Array.isArray(response.data)) {
            // Direct array format
            devicesArray = response.data;
        } else if (response.data?.items && Array.isArray(response.data.items)) {
            // Wrapped format with items property
            devicesArray = response.data.items;
        } else if (response.data?.member && Array.isArray(response.data.member)) {
            // API Platform format with member property
            devicesArray = response.data.member;
        }
        
        return { items: devicesArray } as GetDevicesResponse;
    } catch (error) {
        console.error("Error fetching devices:", error);
        return null;
    }
};



// Device the Device

export const deleteDevice = async (deviceId: number): Promise<void> => {
    try {
        await apiService.delete(`/devices/${deviceId}`);
    } catch (error) {
        console.error(`Error deleting device with ID ${deviceId}:`, error);
        throw error;
    }
};



// Create Device
export const createDevice = async (
    data: CreateDeviceRequest
): Promise<CreateDeviceRequest> => {
    const payload: any = {
        name: data.name,
        identifier: String(data.identifier).toLowerCase(),
        workplace: `api/workplaces/${(data as any).workplace?.id ?? Number(localStorage.getItem('workplace-id'))}`,
    };
    const response = await apiService.post<CreateDeviceRequest>(
        "/devices",
        payload
    );
    return response.data;
};


